module.exports = __webpack_public_path__ + "static/media/Portal_Logo_Small.f704a8d5.svg";